import React, { useEffect, useState, ChangeEvent, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import Swal from 'sweetalert2'

import Dropzone from '../../components/Dropzone';

import './styles.css';

import logo from '../../assets/logo.svg';

import moto from '../../assets/moto.svg'
import bike from '../../assets/bike.svg';
import van from '../../assets/van.svg';

interface Item {
  id: number;
  title: string;
  image: string;
}

interface Endereco {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  gia: string;
  ddd: string;
  siafi: string;
}

const Deliver = () => {
  const [delivery, setItems] = useState<Item[]>([]);

  const [cep, setCep] = useState('');
  const [addressNumber, setAdressNumber] = useState('');
  const [endereco, setEndereco] = useState<Endereco>();
  const [cidadeUf, setCidadeUf] = useState('');

  const [formData, setFormData] = useState({
    name: '',
    cpf: '',
    email: '',
    whatsapp: ''
  });

  const [alertThumb, setAlertThumb] = useState('');
  const [alertName, setAlertName] = useState('');
  const [alertCpf, setAlertCpf] = useState('');
  const [alertEmail, setAlertEmail] = useState('');
  const [alertWhats, setAlertWhats] = useState('');
  const [alertCep, setAlertCep] = useState('');
  const [alertNumber, setAlertNumber] = useState('');
  const [alertDelivery, setAlertDelivery] = useState('');

  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [selectedFile, setSelectedFile] = useState<File>();

  const history = useHistory();


  useEffect(() => {
    setItems([
      {
        id: 1,
        title: "Moto",
        image: moto
      },
      {
        id: 2,
        title: "Bicicleta",
        image: bike
      },
      {
        id: 3,
        title: "Van/Carro",
        image: van
      },
    ])
  }, []);

  function handleCepInput() {

    setAlertCep('')

    if (cep.length <= 0)
      return setAlertCep('Informe um CEP válido')

    axios.get<Endereco>(`https://viacep.com.br/ws/${cep}/json/`)
      .then(response => {
        setEndereco(response.data)
        setCidadeUf(`${response.data.localidade}/${response.data.uf}`)
      }).catch((error) => {
        return setAlertCep('Informe um CEP válido')
      });

  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;

    setFormData({ ...formData, [name]: value });
  }

  function handleSelectItem(id: number) {
    const alreadySelected = selectedItems.findIndex(item => item === id);

    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter(item => item !== id);

      setSelectedItems(filteredItems);
    } else {
      setSelectedItems([...selectedItems, id]);
    }
  }

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();

    const { name, cpf, email, whatsapp } = formData;
    const delivery = selectedItems;

    setAlertThumb('')
    setAlertName('')
    setAlertCpf('')
    setAlertEmail('')
    setAlertWhats('')
    setAlertDelivery('')
    setAlertCep('')
    setAlertNumber('')

    if (name.length <= 0)
      setAlertName('É necessário informar o nome')

    const regexCpf = /^(?:(\d)\1{10})$|(\D)|^(\d{12,})$|^(\d{0,10})$/g;

    if (cpf.length <= 0)
      setAlertCpf('É necessário informar o CPF')
    else if (cpf.match(regexCpf)) {
      setAlertCpf('Oops! CPF inválido')
      return
    }

    const regexEmail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/

    if (email.length <= 0)
      setAlertEmail('É necessário informar o email')
    else if (!regexEmail.test(email))
      setAlertEmail('Oops! Email com formato inválido.')

    const regexWhats = /^([0-9]{2})([0-9]{4,5})([0-9]{4})$/;
    var result = whatsapp.replace(/\W+/g, "")

    if (whatsapp.length > 0) {
      if (!regexWhats.test(result))
        setAlertWhats('Oops! Whatsapp com formato incorreto')
    }

    if (cep.length <= 0)
      setAlertCep('É necessário informar o CEP')

    if (addressNumber.length <= 0)
      setAlertNumber('É necessário informar o número do endereço')

    if (!selectedFile)
      setAlertThumb('Adicione uma foto da sua CNH')

    if (delivery.length <= 0)
      setAlertDelivery('Selecione o método de entrega')

    if (delivery.length > 1) {
      setAlertDelivery('Oops! Selecione apenas um método de entrega')
      return
    }

    if (selectedFile && name && cpf && whatsapp) {
      Swal.fire({
        title: 'Aí Sim...',
        text: 'Recebemos os seus dados. Fique de olho na sua caixa de email, pois e em breve retornamos o contato.',
        icon: 'success',
        confirmButtonText: 'Fechar'
      }).then((result) => {
        if (result.isConfirmed) {
          history.push('/');
        }
      })
    }
  }

  return (
    <div id="page-deliver">
      <header>
        <img src={logo} alt="Buger Eats" width="200px" />

        <Link to="/">
          <FiArrowLeft />
          Voltar para home
        </Link>
      </header>

      <form onSubmit={handleSubmit}>
        <h1>Cadastre-se para <br /> fazer entregas</h1>

        <fieldset>
          <header role="legend">
            <h2>Dados</h2>
          </header>

          <div className="field-group">
            <div className="field">
              <input
                type="text"
                name="name"
                placeholder="Nome completo"
                onChange={handleInputChange}
              />
              {alertName.length > 0 &&
                <span className="alert-error">{alertName}</span>
              }
            </div>
            <div className="field">
              <input
                type="text"
                name="cpf"
                placeholder="CPF somente números"
                onChange={handleInputChange}
              />
              {alertCpf.length > 0 &&
                <span className="alert-error">{alertCpf}</span>
              }
            </div>
          </div>

          <div className="field-group">
            <div className="field">
              <input
                type="email"
                name="email"
                placeholder="E-mail"
                onChange={handleInputChange}
              />
              {alertEmail.length > 0 &&
                <span className="alert-error">{alertEmail}</span>
              }
            </div>
            <div className="field">
              <input
                type="text"
                name="whatsapp"
                placeholder="Whatsapp"
                onChange={handleInputChange}
              />
              {alertWhats.length > 0 &&
                <span className="alert-error">{alertWhats}</span>
              }
            </div>
          </div>
        </fieldset>

        <fieldset>
          <header role="legend">
            <h2>Endereço</h2>
            <span>Informe o cep, número e complemento</span>
          </header>

          <div className="field-group">
            <div className="field">
              <input
                type="text"
                name="postalcode"
                placeholder="CEP"
                value={cep}
                onChange={(e) => { setCep(e.target.value) }}
              />
              {alertCep.length > 0 &&
                <span className="alert-error">{alertCep}</span>
              }
            </div>
            <div className="field">
              <input type="button" value="Buscar CEP" onClick={handleCepInput} />
            </div>
          </div>

          <div className="field">
            <input
              type="text"
              name="address"
              placeholder="Rua"
              value={endereco?.logradouro}
              disabled
            />
          </div>

          <div className="field-group">
            <div className="field">
              <input
                type="text"
                name="address-number"
                placeholder="Número"
                value={addressNumber}
                onChange={(e) => { setAdressNumber(e.target.value) }}
              />
              {alertNumber.length > 0 &&
                <span className="alert-error">{alertNumber}</span>
              }
            </div>
            <div className="field">
              <input
                type="text"
                name="address-details"
                placeholder="Complemento"
              />
            </div>
          </div>

          <div className="field-group">
            <div className="field">
              <input
                type="text"
                name="district"
                placeholder="Bairro"
                value={endereco?.bairro}
                disabled
              />
            </div>
            <div className="field">
              <input
                type="text"
                name="city-uf"
                placeholder="Cidade/UF"
                value={cidadeUf}
                disabled
              />
            </div>
          </div>

        </fieldset>

        <fieldset>
          <header role="legend">
            <h2>Método de entrega</h2>
            <span>Escolha um dos métodos abaixo:</span>
          </header>

          <ul className="delivery-method">
            {delivery.map(item => (
              <li
                key={item.id}
                onClick={() => handleSelectItem(item.id)}
                className={selectedItems.includes(item.id) ? 'selected' : ''}
              >
                <img src={item.image} alt={item.title} width="80" />
                <span>{item.title}</span>
              </li>
            ))}
          </ul>

          {alertDelivery.length > 0 &&
            <span className="alert-error">{alertDelivery}</span>
          }
        </fieldset>

        <Dropzone onFileUploaded={setSelectedFile} />
        {alertThumb.length > 0 &&
          <span className="alert-error">{alertThumb}</span>
        }

        <button type="submit" className="button-success">
          Cadastre-se para fazer entregas
        </button>
      </form>

    </div>
  );
};

export default Deliver;
